import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './Mode.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import useActionCommand from '@/hooks/command/mavlink/useActionCommand';
import EventEmitter from '@/libs/EventEmitter';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeMavLinkCommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const Mode = ({ data: robots, modeId, desc }) => {
  const dispatch = useDispatch();
  const [isProcessing, setProcessing] = useState(false);
  const actionCommand = useActionCommand();

  //#region Process Functions
  const process = async (robot) => {
    try {
      await executeMavLinkCommand(robot, actionCommand.setMode(modeId));

      onSuccess(robot);
    } catch (error) {
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  // 성공 시 처리
  const onSuccess = (robot) => {
    EventEmitter.publish(`${robot.id}/event/removeGoto`);

    notifier.success(`Mode set successfully on ${robot.name}.`);
    setProcessing(false);
  };

  // 실패 시 처리
  const onFailure = (robot) => {
    notifier.error(`Failed to set mode on ${robot.name}.`);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    robots.forEach((robot) => process(robot));
  }, [isProcessing]);

  const doCommand = () => {
    // 처리 중 상태로 변경
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>{desc}</div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

export default Mode;
